export const isValidImageUrl = (url, timeoutMs = 10000) =>
  new Promise((resolve) => {
    if (typeof url !== 'string' || !url.trim()) {
      resolve(false)
      return
    }

    const image = new Image()
    const finish = (valid) => {
      clearTimeout(timer)
      image.onload = null
      image.onerror = null
      resolve(valid)
    }
    const timer = setTimeout(() => finish(false), timeoutMs)

    image.onload = () => finish(image.naturalWidth > 0 && image.naturalHeight > 0)
    image.onerror = () => finish(false)
    image.src = url
  })
